export default {
  init() {
      initMap();
    
      function initMap() {

      window.map = new window.google.maps.Map(document.getElementById('map'), {
        center: {lat: 47.627185, lng: -122.190080},
        zoom: 14,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.LEFT_TOP,
        },
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,

        styles: [
          {"elementType": "geometry", "stylers": [{"color": "#1d2c4d"}] },
          {"elementType": "labels.text.fill","stylers": [{"color": "#8ec3b9"}]},
          {"elementType": "labels.text.stroke","stylers": [{"color": "#1a3646"}]},
          {"featureType": "administrative","elementType": "geometry","stylers": [{"visibility": "off"}]},
          {"featureType": "administrative.country","elementType": "geometry.stroke","stylers": [{"color": "#4b6878"}]},
          {"featureType": "administrative.land_parcel","elementType": "labels.text.fill","stylers": [{"color": "#64779e"}]},
          {"featureType": "administrative.province","elementType": "geometry.stroke","stylers": [{"color": "#4b6878"}]},
          {"featureType": "landscape","elementType": "geometry.fill","stylers": [{"color": "#3e5962"}]},
          {"featureType": "poi","stylers": [{"visibility": "off"}]},
          {"featureType": "poi","elementType": "geometry","stylers": [{"color": "#283d6a"}]},
          {"featureType": "poi","elementType": "labels.text.fill","stylers": [{"color": "#6f9ba5"}]},
          {"featureType": "poi","elementType": "labels.text.stroke","stylers": [{"color": "#1d2c4d"}]},
          {"featureType": "road", "elementType": "geometry","stylers": [{"color": "#304a7d"}]},
          {"featureType": "road","elementType": "geometry.fill","stylers": [{"color": "#138c83"},{"weight": 5}]},
          {"featureType": "road","elementType": "geometry.stroke","stylers": [{"visibility": "off"}]},
          {"featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "road", "elementType": "labels.text.fill", "stylers": [ { "color": "#7eada7" } ] },
          {"featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1f3f4a" } ] },
          {"featureType": "road.arterial", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "road.highway", "elementType": "labels", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "road.local", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "transit", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "color": "#98a5be" } ] },
          {"featureType": "transit", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1d2c4d" } ] },
          {"featureType": "transit.line", "elementType": "geometry.fill", "stylers": [ { "color": "#283d6a" } ] },
          {"featureType": "transit.station", "elementType": "geometry", "stylers": [ { "color": "#3a4762" } ] },
          {"featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#1f3f4a" } ] },
          {"featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#4e6d70" } ] },
        ],
      });

        new window.google.maps.Marker({
          position: new window.google.maps.LatLng(47.627185, -122.190080),
          icon: '../../map-icon-hover.png',
          map: window.map,
        });
        window.map.panTo(new window.google.maps.LatLng(47.627185, -122.190080));
        
    }
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
